/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DtmDocsCloseInterruptPartialUpdateRequest = {} | null | undefined;
export type DtmDocsCloseInterruptPartialUpdateResponse = any;

export type DtmDocsCloseInterruptPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dtm_docs/{id}/close_interrupt/
 *
 * ```yaml
 * operationId: dtm_docs_close_interrupt_partial_update
 * tags:
 *   - dtm_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dtmDocsCloseInterruptPartialUpdateOperation = ({
  id,
  ...rest
}: DtmDocsCloseInterruptPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dtm_docs/${id}/close_interrupt/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dtm_docs/{id}/close_interrupt/' };
  };

/**
 * PATCH /dmx-server/dtm_docs/{id}/close_interrupt/
 *
 * ```yaml
 * operationId: dtm_docs_close_interrupt_partial_update
 * tags:
 *   - dtm_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dtmDocsCloseInterruptPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DtmDocsCloseInterruptPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dtmDocsCloseInterruptPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
